export default __webpack_public_path__ + "static/media/menu-icon.a6bc3946.svg";